export default "__VITE_ASSET__C9JjK5OI__"